import Icon from '../components/Icon.vue'

Icon.register({
  strikethrough: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 224c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-480c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h102.3c-11.7-16.5-19.8-35.5-21.8-56.4-0.3-3.3-0.6-8.7-0.6-12 0-68.2 55.4-123.6 123.6-123.7h68 0c43.7 0 95 31.7 114.5 70.8l0.5 1c0.9 1.9 1.7 5.1 1.7 7.1 0 5.5-4 11.9-8.8 14.3l-42.9 21.5c-1.9 0.9-5.1 1.7-7.2 1.7-5.5 0-11.9-4-14.3-8.8-7.6-15.2-27.6-27.6-44.6-27.6h0-66.8c-24 0-43.5 19.5-43.5 43.5 0 17.7 13.8 36.4 30.7 41.6l87.2 26.8h202.1zM315.8 320h94.4c2.2 6.6 4.6 17.5 5.3 24.4 0.3 3.3 0.6 8.7 0.6 12 0 68.2-55.4 123.6-123.6 123.7h-68 0c-43.7 0-95-31.7-114.5-70.8l-0.5-1c-0.9-1.9-1.7-5.1-1.7-7.1 0-5.5 4-11.9 8.8-14.3l42.9-21.5c1.9-0.9 5.1-1.7 7.2-1.7 5.5 0 11.9 4 14.3 8.8 7.6 15.2 27.6 27.6 44.6 27.6h0 66.8c24 0 43.5-19.5 43.5-43.5 0-13.2-9.1-29.5-20.2-36.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/strikethrough.js
// module id = 1959
// module chunks = 0